import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import ProfileImage from "@widget/other/ProfileImage";
import { hasValue } from "@utils";
/**
 * @export
 * A compact card for a list row: title, subtitle and meta on the left (one line each),
 * picture and status on the right. Use it for the compact column of an object search
 * (phones, and while the details panel is open).
 *
 * @example User
 * ```tsx
 * <ListItemCard
 *     title="Asha Fernando"
 *     subtitle="asha@company.com"
 *     meta="Facility Managers"
 *     name="Asha Fernando"
 *     status={<Chip label="Active" />}
 * />
 * ```
 *
 * @example Name only
 * ```tsx
 * <ListItemCard title="System Administrator" name="System Administrator" />
 * ```
 *
 * @category Lists
 */
const ListItemCard = ({ title, subtitle, meta, image, name, status, lines, className }) => {
    const hasPicture = hasValue(image) || hasValue(name);
    return _jsxs("div", { className: classNames("uxpcore_listitemcard", className), children: [_jsxs("div", { className: "uxpcore_listitemcard__text", children: [_jsx("div", { className: "uxpcore_listitemcard__title", children: title }), hasValue(subtitle) && _jsx("div", { className: "uxpcore_listitemcard__subtitle", children: subtitle }), hasValue(meta) && _jsx("div", { className: "uxpcore_listitemcard__meta", children: meta }), lines === null || lines === void 0 ? void 0 : lines.map((line, i) => _jsxs("div", { className: "uxpcore_listitemcard__line", children: [_jsx("span", { className: "uxpcore_listitemcard__label", children: line.label }), _jsx("span", { className: "uxpcore_listitemcard__value", children: line.value })] }, i))] }), (hasPicture || hasValue(status)) && _jsxs("div", { className: "uxpcore_listitemcard__side", children: [hasPicture && _jsx(ProfileImage, { image: image, name: name, size: "small" }), hasValue(status) && _jsx("div", { className: "uxpcore_listitemcard__status", children: status })] })] });
};
export default ListItemCard;
